import { requests } from "./api-config";
export const Album = {
  getByPage: (data) => requests.post(true ,"album/p", JSON.stringify(data)  ),
  create: (data) => requests.post(true ,"album/create", JSON.stringify(data) ),
  edit: (data) => requests.post(true ,"album/edit", JSON.stringify(data) ),
  get: (data) => requests.post(true ,"album/get", JSON.stringify(data) ),
  remove: (data) => requests.post(true ,"album/remove", JSON.stringify(data) ),
  get: (data) => requests.post(true ,"album/get", JSON.stringify(data) ),
};
